import React from 'react';
import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/core';
import JumpToComponent from './jumpto.component';

import {
    Grid,
    lineHeight,
    MixBlendDifference,
    MixBlendText,
    responsiveFontSize,
    zIndexes,
} from 'style';

const HeroServicesComponent = ({
    label,
    headline,
    titleForMobileDevices,
    disableDifferenceEffect,
    backgroundColor,
    textColor,
    caseSections,
}) => {
    return (
        <div>
            <HeroServices
                id="HeroServices"
                backgroundColor={backgroundColor && backgroundColor.hex}
                textColor={textColor && textColor.hex}>
                <div className="services-container">
                    <div className="wrapper">
                        
                        <div className="container-fluid">
                            <div className="spacer mh-120" size="45"></div>
                            <div className="row mb-auto">
                                <div className="col-xs-12 col-sm-8 col-sm-offset-4">
                                    <label className="tomoslab">{label}</label>
                                    <h1 className="tomoslab hero">{headline}</h1>

                                    <div className="spacer" size="56"></div>
                                    {/* <JumpToComponent caseSections={caseSections} /> */}
                                </div>
                            </div>
                            
                            
                            
                            <div className="spacer" size="21"></div>
                        </div>
                
                    </div>
                </div>
                
            <JumpToComponent caseSections={caseSections} />
            <Blackblock/>
            <Whiteblock/>
            </HeroServices>
        </div>
    );
};
const HeroTextWrapperAnim = keyframes`
0%{
  opacity: 0;
  transform: translateY(40px);
}
100%{
  opacity: 1;
  transform: translateY(0px);
}
`;

const Blackblock = styled.div`
    position: absolute;
    z-index: 3;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: black;
    // background-color: ${props => props.backgroundColor || ''};
    // color: ${props => props.textColor || ''};
`
const Whiteblock = styled.div`
    position: fixed;
    z-index: 2;
    top: 0;
    width: 100%;
    height: 4rem;
    background-color: white;
    border-bottom: 1px solid #E5E5E5;
`

const HeroServices = styled.div`
    position: relative;
    
    color: ${props => props.textColor || ''};
    min-height: calc(100vh - 10px);
    @media(orientation: landscape){
        min-height: calc(100vh - 10px);
    }

    align-items: flex-end;
    display: flex;

    label {
        display: block;
        margin-bottom: 0.75em;
    }
    label,
    h1 {
        opacity: 0;
        transform: translateY(40px);
        animation: ${HeroTextWrapperAnim} 1s 0.2s forwards;
    }
    h1 {
        animation-delay: 0.4s;
    }

    .mh-120{
        min-height: 120px;
    }

    .tomoslab {
        font-family: 'TomoSlab';
        font-weight: 100;
    }

    .services-container{
        
        position: absolute;
        top: 0;
        z-index: 4;
        display: flex;
        width: 100%;

        & > .wrapper > .container-fluid{
            display: flex;
            flex-direction: column;
        }
        .mb-auto{
            margin-bottom: auto;
        }


        ${MixBlendDifference};
    }


`;

export default HeroServicesComponent;
